exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-main{padding:15px 10px 50px}", "", {"version":3,"sources":["D:/Workspace/haiyun/ViewProjects/dashboard/src/views/layout/AppMain.vue"],"names":[],"mappings":"AACA,UAEC,sBAAmB,CAGnB","file":"AppMain.vue","sourcesContent":["\n.app-main{\n\tpadding-top: 15px;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\tpadding-bottom: 50px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0afb19aa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/AppMain.vue
// module id = V0Mc
// module chunks = 49